// Code variants embedded in data-code-variants for the markdown and llms.txt
// exports, which are built from static HTML and so never see the runtime
// docs-fern-sdk flag. DOCS_FERN_SDK_EXPORT is the build-time counterpart; it
// defaults on in next.config.js, and an empty value turns it off.
export const FERN_GO_EXPORT_LABEL =
  '// Plaid Go SDK v49 (github.com/plaid/plaid-go/v49)';
export const LEGACY_GO_EXPORT_LABEL =
  '// Legacy Plaid Go SDK (github.com/plaid/plaid-go/v48/plaid)';

interface FernGoVariant {
  code?: string;
  unavailable?: string;
}

const stripAuthTags = (code: string): string =>
  code
    .replace(/<(?:\/)?Client(?:QD?)?>/g, '')
    .replace(/<(?:\/)?Secret(?:QD?)?>/g, '');

export const buildLlmVariants = (
  variants: Partial<Record<string, string>>,
  fernGo: FernGoVariant,
  includeFernGo: boolean,
): Record<string, string> => {
  const entries: Array<[string, string]> = [];
  for (const [lang, code] of Object.entries(variants)) {
    if (code === undefined) continue;
    const declaresFernGo =
      fernGo.code !== undefined || fernGo.unavailable !== undefined;
    if (lang !== 'go' || !includeFernGo || !declaresFernGo) {
      entries.push([lang, code]);
      continue;
    }
    if (fernGo.code) {
      entries.push(['go', `${FERN_GO_EXPORT_LABEL}\n${fernGo.code}`]);
    }
    // The exporter fences any `go-*` key as go, so the label is what tells
    // readers which SDK generation the example uses.
    entries.push(['go-legacy', `${LEGACY_GO_EXPORT_LABEL}\n${code}`]);
  }
  return Object.fromEntries(
    entries.map(([lang, code]) => [lang, stripAuthTags(code)]),
  );
};
